import styled, { css } from 'styled-components';
import {
  display,
  flexbox,
  space,
  color,
  fontWeight,
  layout,
  position,
} from 'styled-system';

/**
 * Box 컴포넌트 Props
 * @typedef {Object} BoxProps
 * @property {boolean} [center] - 중앙 정렬 여부
 */

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  
  ${flexbox}
  ${space}
  ${color}
  ${layout}
  ${position}
  ${fontWeight}
  ${(p) =>
    p.center &&
    css`
      align-items: center;
      justify-content: center;
      flex: 1;
    `}
`;

export default Box;
